import { useEffect, useRef } from "react";
import { getLiveLevels } from "../lib/voiceMetrics";

// 녹음 중 라이브 비주얼(§4): 로딩의 그 '물결치는 흰 선'과 동일한 결.
// 단 음량에 반응한다 — 말하면 진폭이 커져 출렁, 조용하면 잔잔. "지금 네 목소리를 듣고 있다"는 증거.
// rAF로 자체 애니메이션(Vent 리렌더 안 함). 파동은 흘러가고(float), 진폭은 실시간 음량으로.
const N = 48; // 곡선 점 수(부드럽게)
const W = 160; // 로딩 svg와 동일 좌표계
const H = 46;
const WAVES = 2.6; // 험프 수(로딩 라인과 비슷)

export default function VoiceViz() {
  const lineRef = useRef<SVGPathElement>(null);
  const phaseRef = useRef(0);
  const ampRef = useRef(0); // 이징된 음량 진폭

  useEffect(() => {
    let raf = 0;
    let last = performance.now();
    const tick = (now: number) => {
      const dt = Math.min(64, now - last);
      last = now;
      // 최근 음량(반응성 위해 최근 몇 샘플의 최댓값)
      const levels = getLiveLevels();
      const recent = levels.length ? Math.max(...levels.slice(-4)) : 0;
      ampRef.current += (recent - ampRef.current) * 0.18; // 부드럽게 따라감
      phaseRef.current += dt * 0.004; // 파동이 흘러가는 속도(float)

      const cy = H / 2;
      const maxA = H / 2 - 3;
      const amp = (0.12 + ampRef.current * 0.88) * maxA; // 조용해도 미세한 물결 유지
      let d = "";
      for (let i = 0; i <= N; i++) {
        const x = (i / N) * W;
        const w = Math.sin((i / N) * WAVES * Math.PI * 2 + phaseRef.current);
        const y = cy - w * amp;
        d += `${i === 0 ? "M" : "L"}${x.toFixed(1)},${y.toFixed(1)} `;
      }
      lineRef.current?.setAttribute("d", d);
      raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, []);

  return (
    <svg
      className="voice-viz"
      viewBox={`0 0 ${W} ${H}`}
      preserveAspectRatio="none"
      fill="none"
      aria-hidden="true"
    >
      <path
        ref={lineRef}
        stroke="#fff"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        vectorEffect="non-scaling-stroke"
      />
    </svg>
  );
}
